import React from "react";
import { Page, PageHeader } from "components/ui/Page";
import { PageColumn, EvenThirdsLayout } from "components/ui/PageColumns";
import { Link } from "react-router-dom";

import { LargeSpacer } from "components/ui/VerticalSpacers";

import WithCurrentCourse from "components/data/WithCurrentCourse";
import CourseContext from "components/contexts/CourseContext";

import { SemesterLink } from "components/ui/SemesterLink";
import { TextbooksCard } from "components/cards/TextbooksCard";
import { ClassInformationCard } from "components/cards/ClassInformationCard";
import { CourseSitesCard } from "components/cards/CourseSitesCard";
import InstructorsCard from "components/cards/InstructorsCard";

// https://wikihub.berkeley.edu/display/SIS/CalCentral+Class+Page
export default function AcademicClassPage() {
  return (
    <Page>
      <WithCurrentCourse>
        <CourseContext.Consumer>
          {({ currentCourse, currentSection }) => {
            if (currentCourse) {
              return (
                <>
                  <PageHeader>
                    <Link to="/academics">My Academics</Link>
                    <> » </>
                    <SemesterLink />
                    <> » </>
                    {currentCourse.course_code}
                    {currentSection && currentSection.section_label && (
                      <span>
                        <> » </>
                        {currentSection.section_label}
                      </span>
                    )}
                  </PageHeader>
                  <LargeSpacer />
                  <EvenThirdsLayout>
                    <PageColumn>
                      <ClassInformationCard />
                    </PageColumn>
                    <PageColumn>
                      <InstructorsCard course={currentCourse} />
                      <CourseSitesCard course={currentCourse} />
                    </PageColumn>
                    <PageColumn>
                      <TextbooksCard />
                    </PageColumn>
                  </EvenThirdsLayout>
                </>
              );
            }
            return null;
          }}
        </CourseContext.Consumer>
      </WithCurrentCourse>
    </Page>
  );
}
AcademicClassPage.displayName = "AcademicClassPage";
